import script from "./Step1.vue?vue&type=script&setup=true&lang=ts"
export * from "./Step1.vue?vue&type=script&setup=true&lang=ts"

import "./Step1.vue?vue&type=style&index=0&id=05757afb&lang=less&scoped=true"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05757afb"]])

export default __exports__